import axios from 'axios';
import config from '../config';

export const getApplicationsVersions = (): Promise<string[]> => {
    return axios.get(`${config.API_URL}/system/application-versions`).then((response: any) => {
        return response.data.data.applicationVersions;
    });
};
